/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";

// // Locations for markers
// const locations = [
//   { name: "Ahmedabad", position: [23.0225, 72.5714] },
//   { name: "Rajasthan", position: [27.0238, 74.2179] },
// ];

const MapMyIndia = () => {

    // const latitude = 22.28369495404497;
    // const longitude = 73.16453595062923;
    // const zoom = 14; // You can adjust the zoom level as needed

    // const mapSrc = `https://www.google.com/maps?q=${latitude},${longitude}&z=${zoom}&output=embed`;


    return (
        <div className="my-map-india">
            {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.4106602831424!2d73.1812181149121!3d22.307158985323542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8e3afc00001%3A0x6263b399d1db8170!2sVadodara%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1624523797308!5m2!1sen!2sin&zoom=100"
                className="h-100 w-100"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Vadodara Map"
            ></iframe> */}
            {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1579174.933970993!2d70.40464749728939!3d22.303015156209104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8d6e8b6e32f%3A0xb5ad30a466be2a4d!2sGujarat%2C%20India!5e0!3m2!1sen!2sin!4v1624531315825!5m2!1sen!2sin&zoom=100"
                className="h-100 w-100"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Gujarat Map"
                zoom="100"
            ></iframe> */}
            {/* <iframe
                title="Vadodara Map"
                className="h-100 w-100"
                src={mapSrc}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                zoom="100"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe> */}
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d189.5799102192683!2d73.164666!3d22.283636!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fa27b80ab10535%3A0x87d2981fef38222c!2sVarahiSoft!5e1!3m2!1sen!2sus!4v1764573005353!5m2!1sen!2sus" width="100%" height="100%" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d210.51290545625642!2d73.16453595062923!3d22.28369495404497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc73ffe7c5dbd%3A0xa16094dd5e51473e!2sZorba!5e1!3m2!1sen!2sin!4v1764572167324!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}

            {/* <iframe
                title="Vadodara Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.952236624442!2d73.17219751537943!3d22.307158185319735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8b03dcbd2cb%3A0x7fda70d6e3df8b28!2sVadodara%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1610000000000!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe> */}
        </div>
    );
}

export default MapMyIndia;
